import React from 'react';

import { Button, Paper, Stack, Typography } from '@mui/material';

interface Props {
  changedTabs: Array<string>;
  invalidTabs: Array<string>;
  isSaving: boolean;
  onDiscard: () => void;
  onSave: () => void;
}

/** Shown while any tab has unsaved edits; saves every tab's edits together. */
export default function NativeTourSaveBar({ changedTabs, invalidTabs, isSaving, onDiscard, onSave }: Props) {
  if (changedTabs.length === 0) {
    return null;
  }

  return (
    <Paper elevation={6} sx={{ position: 'sticky', bottom: 16, mt: 3, px: 2, py: 1.5 }}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Typography flex={1} color={invalidTabs.length > 0 ? 'error' : undefined}>
          {invalidTabs.length > 0
            ? `Fix the fields marked in red in ${invalidTabs.join(', ')} to save.`
            : `Unsaved changes in ${changedTabs.join(', ')}`}
        </Typography>
        <Button variant="contained" onClick={onSave} disabled={invalidTabs.length > 0 || isSaving}>
          {isSaving ? 'Saving…' : 'Save'}
        </Button>
        <Button variant="text" onClick={onDiscard} disabled={isSaving}>
          Discard
        </Button>
      </Stack>
    </Paper>
  );
}
